import{jsx as e}from"react/jsx-runtime";import{calculateRem as i}from"@vds-core/utilities";import{ColorTokens as r}from"@vds-tokens/color";import t from"styled-components";const o=i("10px"),n=r.elements.primary.onlight.value,d=r.elements.primary.ondark.value,a=r.interactive.disabled.onlight.value,s=r.interactive.disabled.ondark.value,l={disabled:!1,height:20,width:20,surface:"light"},c=t.div.withConfig({displayName:"StyledWrapper",componentId:"VDS__sc-13khj4n-0"})`
  box-sizing: border-box;
`,u=t.div.withConfig({displayName:"StyledOuterCircle",componentId:"VDS__sc-13khj4n-1"})`
  align-items: center;
  border-radius: 50%;
  display: flex;
  height: ${i(20)};
  justify-content: center;
  left: ${i(-20)};
  position: absolute;
  right: 0;
  top: 0;
  width: ${i(20)};
  box-sizing: border-box;
`,h=t.div.withConfig({displayName:"StyledInnerCircle",componentId:"VDS__sc-13khj4n-2"})`
  background-color: ${function({surface:e}){return"dark"===e?d:n}};
  border-radius: 50%;
  height: ${o};
  width: ${o};
  position: absolute;

  ${function({disabled:e,surface:i}){return e&&`\n  background-color: ${"dark"===i?s:a}`}}
`,m=function(i){const{disabled:r,surface:t}=i,o=i.selected||!1;return e(c,{children:e(u,Object.assign({},i,{className:"radioOuter","aria-hidden":!0,children:o&&e(h,{disabled:r,surface:t})}))})};m.defaultProps=l;export{m as default};
